import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  standalone:true,
  selector: 'app-redirect-page',
  template: '',
})
export class RedirectPageComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { 
    const uniqueName = this.route.snapshot.params['uniqueName'];
    this.router.navigate([uniqueName], { relativeTo: this.route.parent });
  }

  ngOnInit(): void {
  }
}
